import AsyncButton from '../../../../shared/Loading/AsyncButton';
const Card = ({
  user,
  isChecked,
  isEliminator,
  isEditor,
  toggleOne,
  editUser,
  askDelete,
}) => {
  return (
    <div className="border border-gray-200 rounded-lg p-3 shadow-sm bg-white">
      <div className="flex items-start gap-2">
        {isEliminator && (
          <input
            type="checkbox"
            className="mt-1 h-4 w-4  accent-personalized"
            checked={isChecked}
            onChange={() => toggleOne(user.Id)}
          />
        )}
        <div className="w-full">
          <p className="text-sm font-semibold text-gray-900">
            {user?.FirstName} {user?.LastName}
          </p>
          <p className="text-xs text-gray-500 break-words">
            {user?.PrincipalEmail}
          </p>
          {user?.AlternativeEmail && (
            <p className="text-xs text-gray-400 break-words">
              Alt: {user?.AlternativeEmail}
            </p>
          )}
          {user?.Role === 'Usuario' && (
            <div className="flex flex-row flex-wrap items-center gap-2 mt-2 max-w-full">
              <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs bg-blue-50 flex-shrink-0 text-blue-700">
                Puntos: <span className="ml-1 font-semibold">{user?.Score}</span>
              </span>

              <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs bg-purple-50 flex-shrink-0 text-purple-700">
                Nivel: <span className="ml-1 font-semibold">{user?.Level}</span>
              </span>
            </div>
          )}
        </div>
      </div>
      <div className="mt-3 flex justify-end gap-2">
        <AsyncButton
          onClick={() => editUser(user)}
          className="inline-flex items-center justify-center px-3 py-1.5 text-xs text-white rounded bg-personalized hover:bg-purple-500"
        >
          {isEditor ? 'Editar' : 'Ver'}
        </AsyncButton>
        {isEliminator && (
          <AsyncButton
            onClick={() =>
              askDelete(
                [user.Id],
                `¿Eliminar a ${user.FirstName} ${user.LastName}? Esta acción no se puede deshacer`
              )
            }
            className="inline-flex items-center justify-center px-3 py-1.5 text-xs text-white rounded bg-red-600 hover:bg-red-400"
          >
            Eliminar
          </AsyncButton>
        )}
      </div>
    </div>
  );
};

export default Card;
